export default {
  'content-flow.none': 'No STEAMS scheme available for this lesson',
  'content-flow.loading': 'Loading...',
  'content-flow.no.slides': 'There are no slides for this lesson',
};
